/** @jsx h */
import { h, Component } from 'preact'
import ClaimCard from './ClaimCard'

class SelectCardList extends Component {
  constructor (props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)

    this.state = {
      somethingChecked: false
    }
  }

  handleChange () {
    this.setState({
      somethingChecked: true
    })
  }

  render () {
    const { claimsListData } = this.props
    const { somethingChecked } = this.state

    const maskVisibility = somethingChecked ? 'is-visible' : ''

    const TickIcon = () => (
      <svg
        class='CheckboxHack-tickIcon'
        xmlns='http://www.w3.org/2000/svg'
        width='48'
        height='48'
        viewBox='0 0 48 48'
      >
        <path d='M14.485 41.896h-.04c-.823-.012-1.608-.35-2.183-.937L.874 29.285c-1.19-1.22-1.162-3.17.066-4.357 1.224-1.185 3.187-1.158 4.38.065l9.22 9.453L42.737 6.984c1.222-1.193 3.18-1.17 4.38.045 1.197 1.216 1.176 3.166-.046 4.356l-30.418 29.63c-.58.564-1.358.88-2.167.88' />
      </svg>
    )

    const claimsList = claimsListData.map(claim => (
      <div class='CheckboxHack' key={claim.id}>
        <ClaimCard {...claim} />
        <input
          type='radio'
          name='claim[id]'
          class='CheckboxHack-formField'
          id={`claim-${claim.id}`}
          value={claim.id}
          onChange={this.handleChange}
        />
        <div class={`CheckboxHack-mask ${maskVisibility}`}>
          <div class='CheckboxHack-tick'>{TickIcon()}</div>
        </div>
      </div>
    ))

    return <div class='ClaimSelectCardList'>{claimsList}</div>
  }
}

export default SelectCardList
